import { createContext, useContext } from "react";

import invariant from "tiny-invariant";

import { Validator } from "shared/api/cosmos/use-validators-query";

type StakingContext = {
  validator: Validator | undefined;
};

export const StakingCtx = createContext<StakingContext | undefined>(undefined);

export const useStaking = () => {
  const ctx = useContext(StakingCtx);
  invariant(ctx, "useStaking must be used within StakingCtx");
  return ctx;
};
